import { Expose, Transform } from 'class-transformer';
import { IsString } from 'class-validator';

export default class Address {
  @Expose({ name: 'street_name' })
  readonly streetName?: string;

  @IsString()
  readonly city?: string;

  @IsString()
  readonly neighborhood?: string;

  @IsString()
  @Expose({ name: 'state_code' })
  readonly stateCode?: string;

  @IsString()
  @Expose({ name: 'postal_code' })
  @Transform((params) => params.value && params.value.replace(/\D/g, ''), {
    toPlainOnly: true,
  })
  readonly postalCode?: string;

  @IsString()
  @Expose({ name: 'building_number' })
  readonly buildingNumber?: string;

  constructor(init: Address);

  constructor(init?: Address) {
    this.streetName = init?.streetName;
    this.city = init?.city;
    this.neighborhood = init?.neighborhood;
    this.stateCode = init?.stateCode;
    this.postalCode = init?.postalCode;
    this.buildingNumber = init?.buildingNumber;
  }
}

export function toAddress({ streetName, buildingNumber, city }: Address): string {
  return `${streetName}, ${buildingNumber} - ${city}`;
}
